// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  E.g. 
  @include mix.position-fix(-15px, 0 0 -15px 0);
  @include mix.respond(1280px) { @include mix.position-reset(); }
*/
.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

.page-header {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 800px) {
  .page-header {
    flex-direction: column;
    text-align: center;
  }
}
.page-header h1.mat-headline-4 {
  color: #2f3164;
  font-size: 25px;
  font-weight: 600;
  margin-bottom: 0;
  margin-top: 0;
}
.page-header h1.text-lg {
  color: #2f3164;
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 600;
}
.page-header__nav {
  align-items: center;
  display: flex;
  margin-top: 0;
}
.page-header__nav *:not(:last-child) {
  margin-right: 1.25em;
}
.page-header__nav p {
  margin: 0;
}
@media only screen and (max-width: 800px) {
  .page-header__nav {
    margin-top: 1.25em;
  }
}
.page-header__image {
  max-height: 84px;
  object-fit: cover;
}

/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
mat-card.mat-mdc-card.page-header {
  padding: 14px 20px !important;
}
mat-card.mat-mdc-card.page-header--condensed {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
mat-card.mat-mdc-card.page-header:not(.page-header--condensed) {
  margin-bottom: 25px;
}

/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
mat-card.mat-mdc-card.page-header.background--removed {
  background-color: transparent;
  border: 0;
  box-shadow: none !important;
  padding: 10px 0 0 0 !important;
  transition: 0s !important;
}
mat-card.mat-mdc-card.page-header.background--removed h1.mat-headline-4,
mat-card.mat-mdc-card.page-header.background--removed h1.text-lg {
  color: rgba(0, 0, 0, 0.87);
}
mat-card.mat-mdc-card.page-header.background--red {
  background-color: #e6c8d0 !important;
}
mat-card.mat-mdc-card.page-header.background--red h1.mat-headline-4,
mat-card.mat-mdc-card.page-header.background--red h1.text-lg {
  color: #6d172e;
}
mat-card.mat-mdc-card.page-header.background--blue {
  background-color: #ebeff6;
}
mat-card.mat-mdc-card.page-header.background--blue h1.mat-headline-4,
mat-card.mat-mdc-card.page-header.background--blue h1.text-lg {
  color: #283b90;
}
mat-card.mat-mdc-card.page-header.background--primary {
  background-color: #2f3164;
  background-image: linear-gradient(105deg, #2f3164 30%, #55559b);
}
mat-card.mat-mdc-card.page-header.background--primary h1.mat-headline-4,
mat-card.mat-mdc-card.page-header.background--primary h1.text-lg {
  color: #fff;
}
mat-card.mat-mdc-card.page-header.background--yellow {
  background-color: #f5d68e;
}
mat-card.mat-mdc-card.page-header.background--yellow h1.mat-headline-4,
mat-card.mat-mdc-card.page-header.background--yellow h1.text-lg {
  color: #2f3164;
}
mat-card.mat-mdc-card.page-header.background--purple {
  background-color: #2f3164;
}
mat-card.mat-mdc-card.page-header.background--purple h1.mat-headline-4,
mat-card.mat-mdc-card.page-header.background--purple h1.text-lg {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/styles/abstracts/_mixins.scss","webpack://./node_modules/@angular/material/core/_core.scss","webpack://./src/app/shared/components/page-header/page-header.component.scss"],"names":[],"mappings":"AAyBE;;;;CAAA;ACmBI;EACE,yJAAA;ACtCR;;ADqCM;EACE,0JAAA;AClCR;;ADiCM;EACE,0JAAA;AC9BR;;AD6BM;EACE,0JAAA;AC1BR;;ADyBM;EACE,2JAAA;ACtBR;;ADqBM;EACE,2JAAA;AClBR;;ADiBM;EACE,4JAAA;ACdR;;ADaM;EACE,4JAAA;ACVR;;ADSM;EACE,4JAAA;ACNR;;ADKM;EACE,4JAAA;ACFR;;ADCM;EACE,8JAAA;ACER;;ADHM;EACE,8JAAA;ACMR;;ADPM;EACE,8JAAA;ACUR;;ADXM;EACE,8JAAA;ACcR;;ADfM;EACE,8JAAA;ACkBR;;ADnBM;EACE,8JAAA;ACsBR;;ADvBM;EACE,+JAAA;AC0BR;;AD3BM;EACE,+JAAA;AC8BR;;AD/BM;EACE,+JAAA;ACkCR;;ADnCM;EACE,+JAAA;ACsCR;;ADvCM;EACE,gKAAA;AC0CR;;AD3CM;EACE,gKAAA;AC8CR;;AD/CM;EACE,gKAAA;ACkDR;;ADnDM;EACE,gKAAA;ACsDR;;ADvDM;EACE,gKAAA;AC0DR;;ADvFE;EACE,6BAAA;AC0FJ;;ADnFI;EACE,yFAAA;EACA,uEAAA;ACsFN;;AFpGI;EELA,uBAAA;EACA,aAAA;EACA,8BAAA;AA6GJ;AFnGI;EAPA;IEAE,sBAAA;IACA,kBAAA;EA8GJ;AACF;AA5GI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AA8GN;AA3GI;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AA6GN;AFvII;EE8BE,mBAAA;EACA,aAAA;EACA,aAAA;AA4GN;AAzGQ;EACE,oBAAA;AA2GV;AAvGM;EACE,SAAA;AAyGR;AFjII;EAjBA;IE6CI,kBAAA;EAyGN;AACF;AFvJI;EEkDE,gBAAA;EACA,iBAAA;AAwGN;;AAnGA,2HAAA;AACA;EACE,6BAAA;AAsGF;AF3JI;EEwDA,4BAAA;EACA,6BAAA;AAsGJ;AAnGE;EACE,mBAAA;AAqGJ;;AAjGA,2HAAA;AFjEI;EEoEA,6BAAA;EACA,SAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;AAmGJ;AAjGI;;EAEE,0BAAA;AAmGN;AF/KI;EEiFA,oCAAA;AAiGJ;AA/FI;;EAEE,cAAA;AAiGN;AFtLI;EE0FA,yBAAA;AA+FJ;AA7FI;;EAEE,cAAA;AA+FN;AF7LI;EEmGA,yBAAA;EAEA,+DAAA;AA4FJ;AAtFI;;EAEE,WAAA;AAwFN;AFrMI;EEkHA,yBAAA;AAsFJ;AApFI;;EAEE,cAAA;AAsFN;AF5MI;EE2HA,yBAAA;AAoFJ;AAlFI;;EAEE,WAAA;AAoFN","sourcesContent":["// BEM Mixins\r\n@mixin e($element) {\r\n    &__#{$element} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin m($modifier) {\r\n    &--#{$modifier} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin c($child) {\r\n    &-#{$child} {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Media Query Mixin\r\n  @mixin respond($respond) {\r\n    @media only screen and (max-width: #{$respond}) {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Position fixing (generally used for forms)\r\n  /*\r\n    E.g. \r\n    @include mix.position-fix(-15px, 0 0 -15px 0);\r\n    @include mix.respond(1280px) { @include mix.position-reset(); }\r\n  */\r\n  @mixin position-fix($top, $margin: 0 0 0 0) {\r\n    margin: $margin;\r\n    position: relative;\r\n    top: $top;\r\n  }\r\n  \r\n  @mixin position-reset() {\r\n    margin: 0;\r\n    position: static;\r\n    top: 0;\r\n  }","@use './m3-app';\n@use './tokens/token-utils';\n@use './style/elevation';\n\n$fallbacks: m3-app.get-tokens();\n\n/// @deprecated This mixin is a no-op and is going to be removed in v21.\n@mixin core() {}\n\n// Emits the mat-app-background CSS class. This predefined class sets the\n// background color and text color of an element.\n@mixin app-background() {\n  // TODO: Move ripple styles to be dynamically loaded instead of in core.\n  // This variable is used as a fallback for the ripple element's\n  // background color. However, if it isn't defined anywhere, then MSS\n  // complains in its verification stage.\n  html {\n    --mat-sys-on-surface: initial;\n  }\n\n  // Wrapper element that provides the theme background when the\n  // user's content isn't inside of a `mat-sidenav-container`.\n  @at-root {\n    // Note: we need to emit fallback values here to avoid errors in internal builds.\n    .mat-app-background {\n      background-color: token-utils.slot(app-background-color, $fallbacks, transparent);\n      color: token-utils.slot(app-text-color, $fallbacks, inherit);\n    }\n  }\n}\n\n// Emits CSS classes for applying elevation. These classes follow the pattern\n// mat-elevation-z#, where # is the elevation number you want, from 0 to 24.\n// These predefined classes use the CSS box-shadow settings defined by the\n// Material Design specification.\n@mixin elevation-classes() {\n  @at-root {\n    // Provides external CSS classes for each elevation value. Each CSS class is formatted as\n    // `mat-elevation-z$z-value` where `$z-value` corresponds to the z-space to which the element\n    // is elevated.\n    @for $z-value from 0 through 24 {\n      $selector: elevation.$prefix + $z-value;\n      // We need the `mat-mdc-elevation-specific`, because some MDC mixins\n      // come with elevation baked in and we don't have a way of removing it.\n      .#{$selector}, .mat-mdc-elevation-specific.#{$selector} {\n        box-shadow: token-utils.slot('app-elevation-shadow-level-#{$z-value}', $fallbacks, none);\n      }\n    }\n  }\n}\n","@use \"sass:map\";\r\n\r\n@use './src/styles/abstracts/mixins' as mix;\r\n@use './src/styles/theme/theme-variables' as theme;\r\n\r\n.page {\r\n  @include mix.c(header) {\r\n    align-items: flex-start;\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    @include mix.respond(800px) {\r\n      flex-direction: column;\r\n      text-align: center;\r\n    }\r\n\r\n    h1.mat-headline-4 {\r\n      color: map.get(theme.$ascend-primary, 500);\r\n      font-size: 25px;\r\n      font-weight: 600;\r\n      margin-bottom: 0;\r\n      margin-top: 0;\r\n    }\r\n\r\n    h1.text-lg {\r\n      color: map.get(theme.$ascend-primary, 500);\r\n      margin-bottom: 0;\r\n      margin-top: 0;\r\n      font-weight: 600;\r\n    }\r\n\r\n    @include mix.e(nav) {\r\n      align-items: center;\r\n      display: flex;\r\n      margin-top: 0;\r\n\r\n      & * {\r\n        &:not(:last-child) {\r\n          margin-right: 1.25em;\r\n        }\r\n      }\r\n\r\n      p {\r\n        margin: 0;\r\n      }\r\n\r\n      @include mix.respond(800px) {\r\n        margin-top: 1.25em;\r\n      }\r\n    }\r\n\r\n    @include mix.e(image) {\r\n      max-height: 84px;\r\n      object-fit: cover;\r\n    }\r\n  }\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\r\nmat-card.mat-mdc-card.page-header {\r\n  padding: 14px 20px !important;\r\n\r\n  @include mix.m(condensed) {\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n\r\n  &:not(.page-header--condensed) {\r\n    margin-bottom: 25px;\r\n  }\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\r\nmat-card.mat-mdc-card.page-header.background {\r\n  @include mix.m(removed) {\r\n    background-color: transparent;\r\n    border: 0;\r\n    box-shadow: none !important;\r\n    padding: 10px 0 0 0 !important;\r\n    transition: 0s !important;\r\n\r\n    h1.mat-headline-4,\r\n    h1.text-lg {\r\n      color: rgba(0, 0, 0, 0.87);\r\n    }\r\n  }\r\n\r\n  @include mix.m(\"red\") {\r\n    background-color: map.get(theme.$i3-colors, \"redBackground\") !important;\r\n\r\n    h1.mat-headline-4,\r\n    h1.text-lg {\r\n      color: map.get(theme.$i3-colors, \"redText\");\r\n    }\r\n  }\r\n\r\n  @include mix.m(\"blue\") {\r\n    background-color: map.get(theme.$i3-colors, \"blueBackground\");\r\n\r\n    h1.mat-headline-4,\r\n    h1.text-lg {\r\n      color: map.get(theme.$i3-colors, \"blueText\");\r\n    }\r\n  }\r\n\r\n  @include mix.m(\"primary\") {\r\n    background-color: map.get(theme.$ascend-primary, 500);\r\n\r\n    background-image: linear-gradient(\r\n      105deg,\r\n      map.get(theme.$ascend-primary, 500) 30%,\r\n      map.get(theme.$ascend-primary, 400)\r\n    );\r\n\r\n    h1.mat-headline-4,\r\n    h1.text-lg {\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  @include mix.m(\"yellow\") {\r\n    background-color: map.get(theme.$i3-colors, \"yellowBackground\");\r\n\r\n    h1.mat-headline-4,\r\n    h1.text-lg {\r\n      color: map.get(theme.$ascend-primary, 500);\r\n    }\r\n  }\r\n\r\n  @include mix.m(\"purple\") {\r\n    background-color: rgba(map.get(theme.$ascend-primary, 500), 1);\r\n\r\n    h1.mat-headline-4,\r\n    h1.text-lg {\r\n      color: #fff;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
